import { createFileRoute } from "@tanstack/react-router";
import HowFastSaintPage from "@/pages/learn/HowFastSaintPage";
import { pageHowFastSaint } from "@/pages/learn/learnDataHowFastSaint";
export const Route = createFileRoute("/learn/how-fast-does-saint-tms-work")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Fast Does SAINT® TMS Work? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "How quickly SAINT® TMS works: the five-day protocol, trial data on time to improvement, the difference between treatment duration and individual response.",
        },
        {
          property: "og:title",
          content: "How Fast Does SAINT® TMS Work? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "How quickly SAINT® TMS works: the five-day protocol, trial data on time to improvement, the difference between treatment duration and individual response.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/how-fast-does-saint-tms-work",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/how-fast-does-saint-tms-work",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageHowFastSaint.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowFastSaintPage />;
}
